import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20competition%20arena%20with%20warm%20golden%20and%20coral%20gradients%2C%20floating%20trophy%20silhouettes%2C%20dynamic%20energy%20waves%2C%20dark%20dramatic%20background%20with%20light%20streaks%2C%20modern%20esports%20stadium%20atmosphere%2C%20cinematic%20lighting%2C%20epic%20scale&width=1600&height=900&seq=hero-bg-2025&orientation=landscape"
          alt="每日大赛Yandex竞技平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-verified-badge-line text-accent-400 text-sm"></i>
            <span className="text-xs text-background-50/90 font-medium">Yandex官方认证竞技平台</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            每日大赛Yandex官网
          </h1>
          <p className="text-lg md:text-xl text-background-50/80 mb-2">
            官方入口 · 权威参赛指南
          </p>
          <p className="text-sm md:text-base text-background-50/60 max-w-2xl mx-auto mb-8 leading-relaxed">
            欢迎访问每日大赛Yandex官网，这里提供最权威的每日大赛Yandex官网入口、注册流程、参赛规则及奖励说明。无论您是新手还是老玩家，通过每日大赛Yandex官网即可轻松参与每日竞技，赢取丰厚奖励。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#register"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-rocket-line mr-2"></i>
              立即参赛
            </a>
            <Link
              to="/category/competition-rules"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium text-base hover:bg-background-50/20 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line mr-2"></i>
              查看规则
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { value: '500万+', label: '注册用户', icon: 'ri-user-star-line' },
              { value: '10万+', label: '日参赛人数', icon: 'ri-group-line' },
              { value: '200+', label: '覆盖国家', icon: 'ri-global-line' },
              { value: '98.7%', label: '用户满意度', icon: 'ri-heart-line' },
            ].map((stat) => (
              <div
                key={stat.label}
                className="flex flex-col items-center gap-1 p-4 rounded-xl bg-background-50/8 backdrop-blur-sm border border-background-50/10"
              >
                <i className={`${stat.icon} text-accent-400 text-xl mb-1`}></i>
                <span className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
                  {stat.value}
                </span>
                <span className="text-xs text-background-50/60">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}